import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { DeleteForever } from '@mui/icons-material';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField
} from "@mui/material";

const ToSchemeForm = ({
    handleChallanFormData, 
    schemeLoading, 
    screenType,
    toSubheadData,
    fy_list,
    handleToSubheadChange,
    toSchemes,
    fromSchemeDetails,
    to_subheadsList,
    totalToAmount,
    handleToActivityChange,
    activity,
    findSubActivitiesById,
    addNewActivity,
    deleteNewActivity,
    fromSubheadsList = [],
    formData
}) => {
    const { authData } = useSelector((state) => state.authData);
    // To Scheme FY can only be same or after the max FY selected in From Subheads.
    const maxSelectedFromStartYear = fromSubheadsList.reduce((maxYear, subhead) => {
        const selectedFromFinancialYear = fy_list.find((fy) => (
            String(fy.id) === String(subhead.from_financial_id) ||
            String(fy.year) === String(subhead.from_financial_id)
        ));

        if (!selectedFromFinancialYear) {
            return maxYear;
        }

        const startYear = Number(selectedFromFinancialYear.start_year);
        if (Number.isNaN(startYear)) {
            return maxYear;
        }

        return maxYear === null ? startYear : Math.max(maxYear, startYear);
    }, null);

    const availableToFinancialYears = (
        maxSelectedFromStartYear === null
            ? fy_list
            : fy_list.filter((fy) => Number(fy.start_year) >= maxSelectedFromStartYear)
    ).slice().sort((a, b) => Number(a.start_year) - Number(b.start_year));

    return (
        <>
            <div className='col-md-12'>
                <h5>To Scheme</h5>
            </div>
            <div className='col-md-4 p-2'>
                <FormControl fullWidth>
                    <InputLabel id="to-financial-year-label">Financial Year *</InputLabel>
                    <Select
                        labelId="to-financial-year-label"
                        id="financial_year"
                        name='to_financial_id'
                        value={toSubheadData.to_financial_id || ""}
                        onChange={handleToSubheadChange}
                        disabled={schemeLoading || screenType == "View" || screenType == "Edit" || fromSubheadsList.length < 1 || availableToFinancialYears.length < 1}
                        label="Financial Year *"
                    >
                        <MenuItem value="">---select year---</MenuItem>
                        {availableToFinancialYears.map((fy) => (
                            <MenuItem value={fy.id} key={fy.id}>{fy.year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="to-scheme-label">Scheme *</InputLabel>
                    <Select
                        labelId="to-scheme-label"
                        id="to_scheme_id"
                        name='to_scheme_id'
                        value={toSubheadData.to_scheme_id || ""}
                        onChange={handleToSubheadChange}
                        label="Scheme *"
                    >
                        <MenuItem value="">Select Scheme</MenuItem>
                        {toSchemes.map((scheme) => (
                            scheme.l2_status == 1 && scheme.l3_status == 1 &&
                            <MenuItem value={scheme.id} key={scheme.id}>{scheme.code}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Scheme Name" type="text" value={fromSchemeDetails.to_scheme_name || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Department Name" type="text" value={fromSchemeDetails.to_department_name || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Grant Code" type="text" value={fromSchemeDetails.to_grant_code || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Type of Scheme" type="text" value={fromSchemeDetails.to_scheme_type || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            <div className='col-md-12 mt-3'>
                <h5>To Subhead</h5>
            </div>
            <div className='col-md-4 p-2'>
                <FormControl fullWidth>
                    <InputLabel id="to-subhead-label">Subhead *</InputLabel>
                    <Select
                        labelId="to-subhead-label"
                        id="to_subhead_id"
                        name='to_subhead_id'
                        value={toSubheadData.to_subhead_id || ""}
                        onChange={handleToSubheadChange}
                        label="Subhead *"
                    >
                        <MenuItem value="">---Select Subhead---</MenuItem>
                        {to_subheadsList.map((subhead) => (
                            <MenuItem value={subhead.id} key={subhead.id}>{subhead.code}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Subhead Name" type="text" value={toSubheadData.subhead_name || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div>
            {/* <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField label="Subhead Balance" type="text" value={toSubheadData.subhead_balance || ""} InputProps={{ readOnly: true }} />
                </FormControl>
            </div> */}
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    {(fromSchemeDetails.to_is_activity_active == 1 && fromSchemeDetails.to_monitoring_level == "1") && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        value={totalToAmount.current}
                        InputProps={{ readOnly: true }}
                        disabled={true}
                    />}
                    {(fromSchemeDetails.to_is_activity_active == 1 && (fromSchemeDetails.to_monitoring_level == "3" && formData.department_type != 'T1')) && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        value={totalToAmount.current}
                        InputProps={{ readOnly: true }}
                        disabled={true}
                    />}
                    {(fromSchemeDetails.to_is_activity_active == 0  || (fromSchemeDetails.to_is_activity_active == 1 && fromSchemeDetails.to_monitoring_level == "2") || (fromSchemeDetails.to_is_activity_active == 1 && fromSchemeDetails.to_monitoring_level == "3" && formData.department_type == 'T1')) && <TextField
                        label="Reappropriation Amount"
                        type="text"
                        name="to_reappropriation_amount"
                        value={toSubheadData.to_reappropriation_amount}
                        onChange={handleChallanFormData}
                    />}
                </FormControl>
            </div>
            {fromSchemeDetails.to_is_activity_active == '1' && ((fromSchemeDetails.to_monitoring_level == "3" && formData.department_type != 'T1') || (fromSchemeDetails.to_monitoring_level == "1")) && <div className="col-md-12" style={{ marginTop: '20px' }}>
                <table className="table table-bordered" style={{ tableLayout: 'auto' }}>
                    <thead className="text-center-custom">
                        <tr>
                            <th scope="col" width="150px">Activity</th>
                            <th scope="col" width="150px">Subactivity</th>
                            <th scope="col" width="300px">Available Balance</th>
                            <th scope="col" width="300px">Amount</th>
                            <th scope="col" width="150px">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center-custom">
                        {toSubheadData?.activity.map((activityData, index) => (
                            <tr key={index}>
                                <td>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name='activity_id'
                                            value={activityData.activity_id || ""}
                                            onChange={(e) => handleToActivityChange(index, e)}
                                            disabled={!toSubheadData.to_subhead_id}
                                            displayEmpty
                                        >
                                            <MenuItem value="">---Select---</MenuItem>
                                            {activity.map(activity => {
                                                if (fromSchemeDetails.to_monitoring_level == "1" || (fromSchemeDetails.to_monitoring_level == "3" && formData.department_type != 'T1')) {
                                                    const exists = toSubheadData.to_scheme_id === activity.scheme_id;
                                                    if (exists) {
                                                        return (
                                                            <MenuItem key={activity.id} value={activity.id}>{activity.activity}</MenuItem>
                                                        )
                                                    }
                                                }
                                            })}
                                        </Select>
                                    </FormControl>
                                </td>
                                <td>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name='subactivity_id'
                                            value={activityData.subactivity_id || ""}
                                            onChange={(e) => handleToActivityChange(index, e, activityData.activity_id)}
                                            disabled={!toSubheadData.to_subhead_id}
                                            displayEmpty
                                        >
                                            <MenuItem value="">---Select---</MenuItem>
                                            {findSubActivitiesById(activityData.activity_id).map(e => {
                                                 return (
                                                    <MenuItem key={e.id} value={e.id}>{e.subactivity}</MenuItem>
                                                )
                                            }
                                            )}
                                        </Select>
                                    </FormControl>
                                </td>
                                <td>{toSubheadData?.activity_budget && toSubheadData?.activity_budget.length != 0 && toSubheadData?.activity_budget.find(e =>
                                    e.subhead_activity_id === activityData.activity_id &&
                                    e.subhead_subactivity_id === activityData.subactivity_id
                                )?.budget}</td>
                                <td>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        name='budget'
                                        placeholder="Enter Release Budget"
                                        value={activityData?.budget}
                                        disabled={!toSubheadData.to_subhead_id}
                                        onChange={(e) => handleToActivityChange(index, e)}
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-primary mx-2" onClick={(e) => addNewActivity('to')}>
                                        <AddIcon />
                                    </button>
                                    {index != 0 && <button type="button"
                                        className="btn btn-danger mx-2"
                                        onClick={(e) => deleteNewActivity(index, 'to')}>
                                        <DeleteForever /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
        </>
    );
}

export default ToSchemeForm;